import {computed, defineComponent, ref, watch} from 'vue';
import {OrganisationInvoiceGroup} from "@/api/klip-api.proxy";

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlInvoiceGroupCard',
    props: {
        group: {
            type: Object as () => OrganisationInvoiceGroup,
            default: () => ({}),
            required: true
        },
        readOnly: {
            type: Boolean,
            required: false,
            default: false
        },
        showContactInfo: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    emits: ['onDelete', 'onUpdate'],
    setup(props,  { emit }) {

        const organisationInvoiceGroup = ref<OrganisationInvoiceGroup>(props.group);
        const organisationInvoiceGroupName = computed(() => {
           return organisationInvoiceGroup.value.name ? `Facturatiegroep: ${organisationInvoiceGroup.value.name}` : 'Facturatiegroep';
        });

        const deleteInvoiceGroup = () => {
            emit('onDelete', organisationInvoiceGroup.value);
        }

        const hasContactInfo = computed(() => {
            if(!props.showContactInfo) return false;
            return !!organisationInvoiceGroup.value.invoiceContactName || !!organisationInvoiceGroup.value.invoiceContactEmail || !!organisationInvoiceGroup.value.invoiceContactPhoneNumber;
        })

        const updateInvoiceGroup = () => {
            const invoiceGroupToUpdate = new OrganisationInvoiceGroup(organisationInvoiceGroup.value);
            emit('onUpdate', invoiceGroupToUpdate);
        }

        watch(() => props.group, (newInvoiceGroup) => { organisationInvoiceGroup.value = newInvoiceGroup }, { immediate: true, deep: true });

        return {
            organisationInvoiceGroup,
            organisationInvoiceGroupName,
            deleteInvoiceGroup,
            updateInvoiceGroup,
            hasContactInfo
        }
    }
})
